import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiUsers, FiAward, FiHeart, FiTarget } from 'react-icons/fi';

const QuemSomos = () => {
  const [conteudo, setConteudo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConteudo();
  }, []);

  const fetchConteudo = async () => {
    try {
      const response = await axios.get('/api/site/quem-somos');
      setConteudo(response.data);
    } catch (error) {
      // Se não houver conteúdo, usar padrão
      setConteudo({
        titulo: 'Quem Somos',
        descricao: 'A NetalimaTurismo é uma empresa dedicada a proporcionar experiências de viagem inesquecíveis.',
        conteudo: 'Somos especialistas em turismo, oferecendo os melhores destinos com conforto, segurança e qualidade.'
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-600"></div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-sky-600 to-sky-500 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-4">{conteudo?.titulo || 'Quem Somos'}</h1>
          <p className="text-xl text-sky-100">{conteudo?.descricao}</p>
        </div>
      </section>

      {/* Conteúdo */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <div className="text-gray-700 leading-relaxed whitespace-pre-line">
              {conteudo?.conteudo || 'Conteúdo em breve...'}
            </div>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="py-16 bg-sky-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Nossos Valores</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-sky-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiUsers className="text-sky-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Compromisso</h3>
              <p className="text-gray-600">Com nossos clientes e parceiros</p>
            </div>
            <div className="text-center">
              <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiAward className="text-yellow-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Qualidade</h3>
              <p className="text-gray-600">Em todos os nossos serviços</p>
            </div>
            <div className="text-center">
              <div className="bg-sky-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiHeart className="text-sky-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Dedicação</h3>
              <p className="text-gray-600">Para tornar sua viagem especial</p>
            </div>
            <div className="text-center">
              <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiTarget className="text-yellow-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Excelência</h3>
              <p className="text-gray-600">Em cada detalhe do seu passeio</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuemSomos;
